module.exports = __webpack_public_path__ + "static/media/inProgress icon.a7020700.png";